import { render, staticRenderFns } from "./BtnEmitirPedido.vue?vue&type=template&id=0ac49f73&"
import script from "./BtnEmitirPedido.vue?vue&type=script&lang=js&"
export * from "./BtnEmitirPedido.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports